import { cn } from "@roman/shared/utils";
import type React from "react";

export const Container = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <div className={cn("py-4", className)}>{children}</div>;
};
